import Hero from "../designSystem/Hero";
import SEO from "../designSystem/SEO";
import MortgageRepaymentCalculator from "../calculators/MortgageRepaymentCalculator";
import CalculatorImage from "../../assets/images/mortgagecalculator_banner.png";
import { ReactComponent as MortgageCalculatorIcon } from "../../assets/icons/mortgage_repayment_calculator.svg";

const CalculatorIcon = () => (
  <span
    className="row-center bg-gray-3 p-m all-radius-l text-primary-2"
    aria-hidden="true"
  >
    <MortgageCalculatorIcon />
  </span>
);

const MortgageCalculatorsPage = () => {
  return (
    <div>
      <SEO
        title="Mortgage Calculators"
        description="Estimate your monthly mortgage repayments using the TAG Mortgages repayment calculator."
        path="/mortgage-calculators"
      />

      <Hero
        title="Mortgage Calculators"
        // subtitle="TAG Mortgages"
        backgroundImage={CalculatorImage}
        showContactButton={false}
      />

      <section className="background-container bg-gray-3">
        <div className="content-container">
        
            {/* <CalculatorIcon /> */}
            <div className="column  gap-l">
              <h2 className="h4 text-primary-1">
                Mortgage Repayment Calculator
              </h2>
              <div className="column gap-m">
                <div className="content text-gray-1">
                  Use our mortgage repayment calculator to estimate your monthly
                  mortgage payments in just a few moments. Simply enter your
                  loan amount, interest rate, mortgage term, and any other
                  relevant details to get an instant estimate of your
                  repayments.
                </div>
                <div className="content text-gray-1">
                  Whether you're buying your first home, moving property, or
                  remortgaging, this calculator can help you understand how
                  different loan amounts, interest rates, and repayment terms
                  could affect your monthly budget. The results are intended as
                  a guide and can help you compare scenarios before speaking
                  with us.
                </div>
              </div>
              <div className="body2 text-primary-1">
                Your home may be repossessed if you do not keep up repayments on
                your mortgage.
              </div>
            </div>
          </div>

    
      </section>

      <MortgageRepaymentCalculator />

      <section className="background-container bg-primary-1">
        <div className="content-container">
          <div className="column-center gap-l">
            <div className="body-2  text-white uppercase">
              - LET’S GET YOU MOVING
            </div>
            <h2 className="h4 text-white text-center">
              Whether you're taking your first step onto the property ladder or
              expanding your investment portfolio, TAG Mortgages is here to
              help.
            </h2>
            <div className="content text-white text-center">
              Get in touch today and discover how simple arranging your mortgage
              can be.
            </div>
            <div className="body1 text-white">
              Your home may be repossessed if you do not keep up repayments on
              your mortgage.
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MortgageCalculatorsPage;
